import { render, staticRenderFns } from "./DistributorClients.vue?vue&type=template&id=d854a624&"
import script from "./DistributorClients.vue?vue&type=script&lang=js&"
export * from "./DistributorClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports